import React from "react";
import { ConceptualRootManagement } from "@components/ConceptualRoot";

export default function ConceptualRootIndex() {
  return <ConceptualRootManagement />;
}
